import {OperatorEnum as E_OperatorEnum, PlatformEnum as PlatformTypeEnum ,DBPlatformEnum,EventActionEnum,AudienceConditionTagEnum,NullabilityEnum} from "src_typescript_appice-core/dist/constants"
import {PushActionBtnTypes} from "src_typescript_appice-core/dist/channels/push/interfaces/interfaces"
import {OperatorTypeEnum} from "src_typescript_appice-core/dist/constants/operators"
import {IntervalEnum,PeriodEnum,ComparisonEnum,ValidatorOptionsEnum,RTLLanguageEnum,BooleanStringEnum ,QueueStatusEnum,SegmentEnum as CustomSegmentEnum} from "src_typescript_appice-core/dist/constants"
import {ConfigTypeEnum,QueueConfigTypeEnum,StorageConfigTypeEnum} from "src_typescript_appice-core/dist/config/interfaces/interfaces.js";
import { OrderByEnum,ApmApiMethods,ApmApiFields,ApmInterval,ApmTimeRange,DeviceIdTypeEnum,Gravity,PeriodTypeEnum} from "src_typescript_appice-core/dist/constants";
import {QueueTypeEnum} from "src_typescript_appice-core/dist/queue/interfaces/interfaces"
export {PlatformTypeEnum,DBPlatformEnum, OperatorTypeEnum,PushActionBtnTypes,IntervalEnum,PeriodEnum,ComparisonEnum,ValidatorOptionsEnum,RTLLanguageEnum,ConfigTypeEnum ,QueueConfigTypeEnum , StorageConfigTypeEnum,E_OperatorEnum,BooleanStringEnum ,OrderByEnum,EventActionEnum,AudienceConditionTagEnum,ApmApiMethods,ApmApiFields,ApmInterval,ApmTimeRange,QueueStatusEnum,CustomSegmentEnum,DeviceIdTypeEnum,Gravity,PeriodTypeEnum,QueueTypeEnum,NullabilityEnum}
export enum AudienceEnum {
  WHO = "who",
  WHAT = "what",
  WHEN = "when",
  WHERE = "where",
  CUSTOM_VARS = "Custom Vars",
  CUSTOM_SEGMENT = "Custom Segment",
  CUSTOM = "custom",
  GF = "gf",
  FS = "fs",
  LS = "ls",
  DEVICE = "Device",
  PLACE_LIST = "placelist",
  TIME_LIST = "timelist",
  BOOLEAN_LIST = "booleanlist",
  NETWORK_LIST = "networklist",
  DEVICE_LANGUAGE_LIST = "deviceLanguagelist",
  AND = "AND",
  OR = "OR",
  CATEGORY_TYPE = "category_type",
  OPERATOR = "operator",
  VALUE = "value",
  OPERAND = "operand",
  EVENTS = "Events",
  H = "h",
  HN = "hn",
  LIVE = "live",
  PAST = "past",
  QUERY = "query",
  TRAIT = "trait",
  SYNC = "sync",
  SPLIT = "split",
  SAVE = "save",
  COUNT = "count",
  INCOMING = "incoming",
  OUTGOING = "outgoing",
  CATEGORY = "category",
  ID = "id",
  CHILDREN = "children",
  GEO = "Geo",
  CTRAIT = "cTrait",
  MODELS = "models",
  EXPORT="export",
  JOURNEY="journey",
  CLIENT_ID = "clientid",
  DEVICE_ID = "did",
  EMAIL = "email",
  PHONE = "phone",
  CUSTOM_AUDIENCE="Custom Audience",
  SYSTEM="system"
  
}
export enum PlatformEnum {
  ALL = "all",
  ANDROID = "android",
  IOS = "ios",
  WEB = "web",
}
export enum CustomDataEnum {
  BOOLEAN="boolean",
  NUMBER="number",
  TREE="json",
  IMAGE="image",
  DEVICE="device"
}

export enum PushNotificationMode {
  DEVELOPMENT = "Development",
  PRODUCTION = "Production"
}
export enum FcmDeliveryMethod {
  JSON = "JSON File",
  FCM_Key = "Server key (legacy)"
}
export enum SelectorModes{
  MULTIPLE="multiple",
  TAGS="tags"
}

export enum GoogleMapShapes{
  CIRCLE="circle",
  POLYGON="polygon",
  RECTANGLE="rectangle"
}

export enum SchedulerPayloadEnum{
  FREQUENCYTYPE = "ft",
  FREQUENCYMODE = "m",
  CAMPAIGNRUNAT = "r",
  WEEKLYDAYS = "d",
  MONTHLYDAYS = "dt",
  INTERVAL = "i",
  INTERVALUNIT = "iu",
  TIME = "t"
}

export enum FrequencyTypeEnum {
  NONE = "n",
  RECURRING = "r",
  ONMULTIPLEDATES = "mm"
}

export enum FrequencyModeTypesEnum {
  DAILY = "d",
  WEEKLY = "w",
  MONTHLY = "m",
  CONTINOUS = "c"
}

export enum IntervalUnitTypesEnum{
  DAYS = "d",
  HOURS = "h",
  MINUTES = "m",
  SECONDS ="s"
}
export enum HighChartTypeEnum{
  PIE="pie",
  SPLINE="spline",

}
export enum SSOTypeEnum{
  LOGIN_EMAIL="login_Email",
  LOGIN_SSO="login_SSO"
}
export enum adAuthTypeEnum{
  SAML="saml",
  AD="ad",
  DISABLED="disabled"
}
export enum userType{
  EMAIL="Email",
  AD="Adid",
}

export enum MinuteEnum {
  TWENTY_FOUR_HOUR = 24 * 60 - 15,
  FIFTEEN_MINUTE_INTERVAL = 15
}

export enum DayAndTimeSelectorEnum {
  ALLWEEK = "ALLWEEK",
  ALLDAY = "ALLDAY",
  SPECIFIC = "SPECIFIC"

}

export enum DeliveryTypeEnum {
  ALL = 'a',
  DIRECTPUSH = "d",
  INBOXONLY = "i"
}

export enum TimeUnitEnum {
  SECONDS = "Seconds",
  MINUTES = "Minutes",
  HOURS = "Hours",
  DAYS = "Days",
  WEEKS="Weeks",
  MONTHS="Months"
  
}

export enum CampaignCategoryEnum {
  ENGAGEMENT = "e",
  GEOFENCE = "g",
  UNINSTALL = "u",
  TRANSACTIONAL = "t"
}

export enum CampaignStatusEnum {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  PAST = "PAST"
}

export enum CampaignTimeRangeEnum{
  STARTTIME = "0800" ,
  ENDTIME = "2000"

}

export enum LaunchCampStagUnitTimeEnum {
  DAYS = "dd",
  HOURS = "hh",
  MINUTES = "mm"
}

export enum CampaignChannelTypeEnum {
  ALL = "All",
  SMS = "SMS",
  IN_APP = "IN-APP",
  PUSH =  "PUSH",
  WEB_PUSH= "WEB_PUSH",
  EMAIL = "EMAIL",
  WHATSAPP ="WHATSAPP",
  WEB_POPUP="WEB_POPUP",
  NATIVE = "NATIVE",
  RCS="RCS",
  LANDING_PAGE="LANDING_PAGE",
  NUDGE="NUDGE",
  IN_APP_RATING = "IN-APP-RATING",
  IN_APP_SURVEY = "IN-APP-SURVEY",
  FACEBOOK = "Facebook",
  GOOGLE = "Google",
  MULTI_STEP="MULTI_STEP",
  CANVAS="CANVAS"




}
export enum CustomUnitsEnum {
  YESTERDAY = "Yesterday",
  TODAY = "Today",
  THIS_WEEK = "This Week",
  LAST_WEEK = "Last Week",
  THIS_MONTH = "This Month",
  LAST_MONTH = "Last Month",
  CUSTOM = "Custom",
}
export enum DateFormatEnum {
  DEFAULT_FORMAT = "MMM D, YYYY",           // Example: Jan 12, 2024
  ISO_FORMAT = "YYYY-MM-DD",                // Example: 2024-12-12
  EU_FORMAT = "DD-MM-YYYY",                 // Example: 12-12-2024
  FULL_DATETIME = "MMMM D, YYYY hh:mm A",   // Example: December 12, 2024 03:15 PM
  SHORT_DATETIME = "MM-DD-YYYY hh:mm A",    // Example: 12-12-2024 03:15 PM
  TIME_ONLY = "hh:mm A",                    // Example: 03:15 PM
  ABBREVIATED_MONTH_TIME = "MMM D, YYYY hh:mm A",  // Example: Dec 12, 2024 03:15 PM
  FULL_MONTH_TIME = "MMMM D, YYYY hh:mm A",         // Example: December 12, 2024 03:15 PM
  FULL_DATETIME_SECONDS = "DD-MM-YYYY hh:mm:ss A"  // Example: 12-12-2024 03:15:30 PM
}


export enum DataTypeEnum {
  STRING = "string",
  NUMBER = "number",
  NUMERIC = "numeric",
  BOOLEAN = "boolean",
  OBJECT = "object",
  ARRAY = "array",
  NULL = "null",
  UNDEFINED = "undefined",
  FUNCTION = "function",
}

export enum KeyboardKeysEnum {
  ENTER = 'Enter',
}
export enum EDStatusEnum{
ENABLE="enable",
DISABLE="disable"
}



export enum AppNavSettingEnum {
  APP_KEYS = "app_keys",
  API_GATEWAY = "api_gateway",
  APP_SETTINGS = "app_settings",
  EMAIL = "email",
  SMS = "sms",
  SECURITY = "security",
  KILL_SWITCH = "kill_switch",
  CHANNEL = "channel",
  APP_INBOX = "app_inbox",
  FILE_ENCRYPTION = "file_encryption",
  UTM_SETTING = "utm_setting",
  CampaignActivationEmail = "CampaignActivationEmail",
  PARTNER_SETTING = "partner_setting",
  ALLOWLIST_SETTING = "allowList_setting",
  PUSH_NOTIFICATION_SETTINGS = "push_notification_settings",
  FEATURES = "features",
  PUSH_NOTIFICATION = "push_notification",
  CAMPAIGN_ANALYTICS = "campaign_analytics",
  CAMPAIGN_CONFIGURATOR = "campaign_configurator",
  SITE_SETTING = "site_setting",
  LOGS = "logs",
  INFRASTRUCTURE = "infrastructureSettings",
  PROVIDER_SETTING = "provider_setting",
  AUDIT_LOGS_CAMPAIGN_CONFIGURATOR = "audit_logs_configurator",
  ATTRIBUTION="attribution",
  CAMPAIGN_SETTING="campaign_setting",
  GEO_SETTINGS="geo_settings",
  APM_SETTINGS="apm_settings",
  FUNNEL_STEPS_LIMIT='funnelStepsLimit',
  ANALYTICS='analytics',
  BUDGET='budget',
  RATE_LIMIT='rateLimit',
  CAMPAIGN_THRESHOLD="campaign_threshold",
  CHANNELS='channels',
  STAGGERED_SEND="staggered_send",
  LANG_ID="lang_id",
  ENGAGEMENT = "engagement"

  





}
export enum ApproveDeclineEnum{
  APPROVED="Approved",
  DECLINED="Declined"
}

export enum SuccessErrorEnum{
  SUCCESS="success",
  ERROR="error"
}
export enum ToolIdEnum {
  PUSH = "PUSH",
  IN_APP = "IN-APP",
  IN_APP_RATING = "IN-APP-RATING",
  IN_APP_SURVEY = "IN-APP-SURVEY",
  SMS = "SMS",
  WEB_PUSH = "WEB_PUSH",
  WEB_POPUP = "WEB_POPUP",
  EMAIL = "EMAIL",
  FACEBOOK = "Facebook",
  WHATSAPP = "WHATSAPP",
  EMPTY = "",
  LANDING_PAGE = "LANDING_PAGE",
  GOOGLE = "Google",
  NATIVE = "NATIVE",
  RCS = "RCS",
  NUDGE="NUDGE",
  MULTISTEP="MULTI_STEP",
  CANVAS="CANVAS"

}

export enum UserRoleEnum {
  GLOBAL_ADMIN = 'global_admin',
  APP_ADMIN = "admin",
  APP_MANAGER = "manager",
  APP_MARKETER = "marketer",
  APP_REVIEWER = "reviewer",
  APP_INFOSEC = "infosec",
 APP_CONTACT_CENTER="contact_center",
 PRODUCT_MANAGER="product_manager"
}

export enum InAppImageUploadType {
  MINI_SCREEN = "miniScreen",
  NOTIFICATION_IMAGE = "notificationImage",
  ICON_IMAGE = "iconImage",
  FOOTER_NOTIFICATION_IMAGE = "footerNotificatonImage",
  IN_APP_EXPANDED = "inAppExpanded"
}
export enum InAppImageValidationType {
  FULL_SCREEN = "inAppNotificationFull",
  MINI_SCREEN = "inAppNotificationMini", 
  EXPANDED = "inAppNotificationHeaderFooterExpanded",
  SMALL = "inAppNotificationSmall",
  MINI_GRAVITY="inAppMiniGravity"
}
export enum Drawer{
WIDTH="580"
}
export enum UploadType {
  NORMAL = "normal",
  EXPANDED = "expanded",
}
export enum ScreenTypes{
  HEADER="Header",
  FOOTER="Footer",
  MINI="Mini",
  FULL_SCREEN="Fullscreen",
  SELF_RENDERED="Selfrendered"
}


export enum EnvironmentType {
  Development = "dev",
  Production = "prod",
}

export enum PlaceholderDateTimeEnum {
  NOT_AVAILABLE_DATE_ISO = "1970-01-01"
}
// Define an enum for the tags
export enum LiveActivityTag {
  Start = "start",
  Update = "update",
  End = "end"
}

export enum BeefreeViewModeEnum{
GLOBAL="global",
MOBILE="mobile",
DESKTOP="desktop"
}

export enum AudienceManagementPageType{
  SEGMENT="segment",
  TRAIT="trait",
  FUNCTION="function",
  FUNNEL="funnel"
}
export enum CountryCityEnum{
  COUNTRY="country",
  CITY="city"
}
export enum OnOffEnum{
ON="ON",
OFF="OFF"
}
export enum PasswordResetModeEnum{
  SMTP="SMTP",
  ADMIN="Admin"
}
export enum InfrastructureNavSetting{
  STORAGE="storage",
  QUEUE="queue",
  GATEWAY="gateway"
}
export enum NumberFormatLocale {
  EN_US = "en-US",       // English (United States)
}

export enum AppTabKey {
  Push = "push",
  Email = "email",
  Sms = "sms",
  WebPush = "webpush",
  Ads = "ads",
  Global = "global",
}

export enum CampaignSettingKey {
  CampaignAnalytics = "campaign-analytics",
  CampaignConfigurator = "campaign-configurator",
  PushNotificationSettings = "push-notification-settings",
  AllowListSettings = "allow-list-settings",
  GeoSettings = "geo-settings",
  Budget = "budget",
  RateLimit = "rate-limit",
  CampaignThreshold = "campaign-threshold",
  StaggeredSend = "staggered-send",
  PartnerSetting = "partner-setting",
  ProviderSetting = "provider-setting",
  AppInboxSetting = "app-inbox-setting",
  BeeFreeEditor="bee-free"
}

export enum SecurityNavSetting {
  GENERAL = 'general',
  LOGS = 'logs',
  AUDIT_CONFIG = 'audit_config',
  FILE_ENCRYPTION = 'file_encryption',
  KILL_SWITCH = 'kill_switch',
}